"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentBtn = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importDefault(require("react"));
var react_loading_skeleton_1 = require("react-loading-skeleton");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var AccountSelectionDropDown_styles_1 = require("../../AccountSelectionDropDown/AccountSelectionDropDown.styles");
var SkeletonWrapper_1 = require("../../SkeletonWrapper");
var PaymentBtnLoadingContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 56px;\n"], ["\n  width: 100%;\n  height: 56px;\n"])));
var PaymentBtn = function (_a) {
    var loading = _a.loading, onClick = _a.onClick, fuelAccount = _a.fuelAccount;
    if (loading) {
        return (react_1.default.createElement(PaymentBtnLoadingContainer, { "data-testid": "paymentBtnSkeleton" },
            react_1.default.createElement(react_loading_skeleton_1.SkeletonTheme, { baseColor: asg_1.colors['grey-2'], highlightColor: AccountSelectionDropDown_styles_1.SKELETON_HIGHLIGHT_COLOR },
                react_1.default.createElement(SkeletonWrapper_1.SkeletonWrapper, { width: "100%", height: "58px", style: { borderRadius: '0px', zIndex: 'inherit' } }))));
    }
    return (react_1.default.createElement(asg_1.ButtonV2, { id: "make-payment-button", primary: true, "data-testid": "paymentBtn", onClick: function (event) {
            event.preventDefault();
            if (fuelAccount)
                onClick(fuelAccount);
        }, loading: loading, disabled: loading }, "Make a payment"));
};
exports.PaymentBtn = PaymentBtn;
var templateObject_1;
//# sourceMappingURL=PaymentBtn.js.map